// Helper function to get tracking identifiers with error handling and retry
async function getTrackingHeaders() {
  try {
    // First attempt to get attributes
    let attributes = window.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes;
    
    // If not available, wait a bit and try again (analytics might still be loading)
    if (!attributes) {
      await new Promise(resolve => setTimeout(resolve, 500));
      attributes = window.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes;
    }
    
    // If still not available, try one more time
    if (!attributes) {
      await new Promise(resolve => setTimeout(resolve, 500));
      attributes = window.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes;
    }
    
    // Only send the unique token for recommendation tracking
    return {
      'X-Unique-Token': attributes?.uniqToken || '',
      'Content-Type': 'application/json'
    };
  } catch (error) {
    console.warn('Failed to extract tracking attributes:', error);
    // Return minimal headers if tracking data is unavailable
    return {
      'Content-Type': 'application/json'
    };
  }
}

// Generic API wrapper that includes tracking headers
async function apiRequest(url, options = {}) {
  const defaultHeaders = await getTrackingHeaders();
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };
  
  return await fetch(url, config);
}

document.addEventListener('DOMContentLoaded', () => {
  // Get the header make/model search elements
  const makeSelect = document.querySelector('.header__make-model-search select[name="make"]');
  const modelSelect = document.querySelector('.header__make-model-search select[name="model"]');
  const searchButton = document.querySelector('.header__make-model-search .make-model-submit');

  // If we don't have the required elements, exit
  if (!makeSelect || !modelSelect || !searchButton) {
    return;
  }

  const API_BASE_URL = 'https://api.hypv.ai/ws/digb/v1';

  // Fetch makes on page load to populate the make select
  const fetchMakes = async () => {
    try {
      const response = await apiRequest(`${API_BASE_URL}/header_make_list`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const makes = await response.json();

      if (makes.length > 0) {
        makes.forEach(make => {
          const option = document.createElement('option');
          option.value = make.symbol;
          option.textContent = make.desc;
          makeSelect.appendChild(option);
        });
      }
    } catch (error) {
      console.error('Error fetching makes:', error);
    }
  };

  // Fetch models when a make is selected
  makeSelect.addEventListener('change', async (event) => {
    const makeSymbol = event.target.value;

    // Reset and disable model select
    modelSelect.innerHTML = '<option value="">Model</option>';
    modelSelect.disabled = true;
    modelSelect.style.backgroundColor = '#D8E0D8';

    // Remove error styling
    modelSelect.style.border = 'none';
    modelSelect.style.boxShadow = 'none';

    if (!makeSymbol) {
      return;
    }

    try {
      const response = await apiRequest(`${API_BASE_URL}/models_for_make/?make=${makeSymbol}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      const models = data?.models || [];

      if (models.length > 0) {
        models.forEach(model => {
          const option = document.createElement('option');
          option.value = model.symbol;
          option.textContent = model.desc;
          modelSelect.appendChild(option);
        });

        modelSelect.disabled = false;
        modelSelect.style.backgroundColor = '';
      }
    } catch (error) {
      console.error('Error fetching models:', error);
    }
  });

  // Handle search button click
  searchButton.addEventListener('click', () => {
    const make = makeSelect.value;
    const model = modelSelect.value;

    // Remove any existing error styling
    modelSelect.style.border = 'none';
    modelSelect.style.boxShadow = 'none';

    if (!make || !model) {
      // Add red ring around the model select element
      modelSelect.style.border = '2px solid red';
      modelSelect.style.boxShadow = '0 0 0 2px white, 0 0 0 4px red';
      modelSelect.focus();
      return;
    }

    // Redirect to the search-by-digger page with parameters including view parameter
    window.location.href = `/pages/search-by-digger?make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}`;
  });

  // Initialize makes
  fetchMakes();
});